export default __webpack_public_path__ + "static/media/conference_action.dd5e7862.svg";